import React, { useState } from "react";
import { Modal, Select } from "antd";
import { CloseCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { StyledButton } from '../../Button';

export const ReOrderLabModal = ({ currentLab, isOpened, onOk, onCancel }) => {
    const [labsCompany, setLabsCompany] = useState(currentLab || 'LabCorp')
    const [isSubmitting, setIsSubmitting] = useState(false)

    const options = [
        { label: 'LabCorp', value: 'LabCorp' },
        { label: 'Quest', value: 'Quest' },
        { label: 'Ash', value: 'Ash'}
    ];

    const handleConfirm = () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        onOk(labsCompany);
    };

    const handleCancel = () => {
        setIsSubmitting(false);
        onCancel();
    };

    return (
        <Modal
            title={`Select Lab Company`}
            destroyOnClose
            width={400}
            open={isOpened}
            onOk={onOk}
            onCancel={onCancel}
            footer={
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <StyledButton 
                        id="reorder-lab-cancel-btn"
                        Icon={CloseCircleOutlined}
                        color='red'
                        tooltip="Cancel"
                        onClick={handleCancel}
                    />
                    <StyledButton 
                        id="reorder-lab-confirm-btn"
                        Icon={CheckCircleOutlined}
                        color='#7BAD7E'
                        tooltip="Confirm"
                        onClick={handleConfirm}
                        loading={isSubmitting}
                    />
                </div>
            }
        >
            <Select
                id="reorder-lab-company-select"
                style={{ width: '100%' }}
                options={options} 
                value={labsCompany} 
                onChange={(lab) => { setLabsCompany(lab) }}
            />
        </Modal>
    )
}

